import React from 'react'

const StatCard = ({ title, value, subValue, className }) => (
  <div className={`p-6 rounded-lg ${className || 'bg-white'}`}>
    <h3 className="text-sm font-medium text-gray-500">{title}</h3>
    <div className="mt-2 flex items-baseline">
      <p className="text-3xl font-semibold">{value}</p>
      {subValue && (
        <p className="ml-2 text-sm text-gray-500">{subValue}</p>
      )}
    </div>
  </div>
)

const RecentDomainCard = ({ domains }) => (
  <div className="bg-white rounded-lg shadow">
    <div className="p-6">
      <h3 className="text-lg font-medium text-gray-900">Recent Domains</h3>
      <div className="mt-4 space-y-3">
        {domains.map((domain, index) => (
          <div key={index} className="flex items-center justify-between">
            <span className="text-sm text-gray-600">{domain.url}</span>
            <span className="text-xs text-gray-500">{domain.addedAt}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
)

const Dashboard = () => {
  // 这里可以通过 API 获取实际数据
  const mockData = {
    totalConfigs: 156,
    activeConfigs: 89,
    totalDomains: 45,
    recentDomains: [
      { url: 'example1.com', addedAt: '2024-03-10' },
      { url: 'example2.com', addedAt: '2024-03-09' },
      { url: 'example3.com', addedAt: '2024-03-08' },
      { url: 'example4.com', addedAt: '2024-03-07' },
    ]
  }

  return (
    <div className="space-y-6">
      {/* 统计卡片网格 */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard
          title="Total Configs"
          value={mockData.totalConfigs}
          className="bg-blue-100"
        />
        <StatCard
          title="Active Configs"
          value={mockData.activeConfigs}
          subValue={`${((mockData.activeConfigs / mockData.totalConfigs) * 100).toFixed(1)}%`}
          className="bg-green-100"
        />
        <StatCard
          title="Total Domains"
          value={mockData.totalDomains}
          className="bg-purple-100"
        />
      </div>

      {/* 最近添加的域名 */}
      <RecentDomainCard domains={mockData.recentDomains} />
    </div>
  )
}

export default Dashboard 